import React, { useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { scrollToTop } from "../../utils/utils";

const RemoteTable = ({ data, totalSize, page, defaultPerPageData, columns, updateData }) => {
  // const [sortField, setSortField] = useState("id");
  // const [sortOrder, setSortOrder] = useState("asc");
  const [sizePerPage, setSizePerPage] = useState(defaultPerPageData || 2);
  const handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
    setSizePerPage(sizePerPage);
    updateData(page, sizePerPage);
    scrollToTop();
    // if (sortField) {
    //   setSortField(sortField);
    //   setSortOrder(sortOrder);
    // }
  };
  const customTotal = (from, to, size) => {
    return <span className="react-bootstrap-table-pagination-total ms-3">Showing {from} to {to} of {size} Results</span>
  }
  const sizePerPageRenderer = ({ options, currSizePerPage, onSizePerPageChange }) => (
    <div className="btn-group" role="group" style={{ border: '1px solid #dee2e6' }}>
      {
        options.map((option) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn ${isSelect ? 'btn-primary' : 'btn-inline-border'}`}
            >
              {option.text}
            </button>
          );
        })
      }
    </div>
  );

  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    return (
      <li className="page-item">
        <a href="#" onClick={handleClick}  className={`btn ${active ? 'btn-primary' : 'btn-inline-border'}`}>{page}</a>
      </li>
    );
  };

  return (
    <div className='table-responsive'>
    <BootstrapTable
      // bootstrap4
      striped
      hover
      keyField="id"
      data={data || []}
      columns={columns}
      remote
      pagination={paginationFactory({
        page,
        totalSize,
        paginationSize: 5,
        pageStartIndex: 1,

        prePageText: 'Back',
        prePageTitle: 'Pre page',
        nextPageText: 'Next',
        nextPageTitle: 'Next page',

        firstPageText: 'First',
        firstPageTitle: 'First page',
        lastPageText: 'Last',
        lastPageTitle: 'Last page',
        withFirstAndLast: false, // Hide the going to First and Last page button

        showTotal: true,
        paginationTotalRenderer: customTotal,

        sizePerPage,
        sizePerPageRenderer,
        sizePerPageList: [{
          text: '5', value: 5
        }, {
          text: '10', value: 10
        }, {
          text: '20', value: 20
        }, {
          text: '50', value: 50
        }],
        pageButtonRenderer,
        // hideSizePerPage: true, // Hide the sizePerPage dropdown always
      })}
      onTableChange={handleTableChange}
      noDataIndication="Table is Empty" 
    />
    </div>
  );
};

export default RemoteTable;
